import React, { useCallback, useState, useContext } from "react";

import TransferList from "./TransferList";
import TransferItem from "./TransferItem";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "shared/hooks/http-hook";
import { StoreContext } from "shared/context/store-context";
import "./Admin.css";

const Transfer = (props) => {
  const store = useContext(StoreContext);
  const { isLoading, error, clearError } = useHttpClient();
  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedItemShow, setSelectedItemShow] = useState(false);

  let pageItems = store.transfers;

  // pageItems = store.ikarusTransfers;
  pageItems = store.ikarusTransfers.filter((item) => item.paid === true);

  const switchItemView = useCallback(() => {
    setSelectedItemShow(true);
  }, [setSelectedItemShow]);

  const ItemSelectHandler = useCallback(
    (itemid) => {
      // setSelectedItemShow(true);
      switchItemView();
      setSelectedItemId(itemid);
    },
    [switchItemView, setSelectedItemId]
  );

  const ItemUpdateHandler = useCallback(
    (itemid) => {
      setSelectedItemId(itemid);
    },
    [setSelectedItemId]
  );

  const switchListView = useCallback(() => {
    setSelectedItemShow(false);
  }, [setSelectedItemShow]);

  // if(isLoading || !store.vehicleRoutes) //HERE
  if (isLoading && false) {
    //HERE
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <div className="adminpageContainer">
        {!isLoading && pageItems && (
          <div className="ikarusListContainer">
            <TransferList items={pageItems} onItemSelect={ItemSelectHandler} />
          </div>
        )}
        {selectedItemId && selectedItemShow && (
          <div className="ikarusUpdateContainer">
            <TransferItem
              itemid={selectedItemId}
              currentTime={Date.now()}
              onItemUpdate={ItemUpdateHandler}
              // onClose={ () => setSelectedItemShow(false) }
              onClose={() => switchListView()}
            ></TransferItem>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Transfer;
